module.exports = __webpack_public_path__ + "media/images/donation/logo-resona-7c37bcd9427f9e68a0603b13f6ecfa3a.jpg";